import { Dispatch, SetStateAction, useEffect } from 'react';

export type Tab = {
    id: string;
    label: string;
};

type TabMenuProps = {
    tabs: Tab[];
    activeTab: string;
    setActiveTab: Dispatch<SetStateAction<string>>;
};

export const MOBILE_MENU_TABPANEL_ID = 'mobile-menu-tabpanel';

export const TabMenu = ({ tabs, activeTab, setActiveTab }: TabMenuProps) => {
    useEffect(() => {
        if (typeof window === 'undefined') return;
        window.localStorage.setItem('activeTab', activeTab);
    }, [activeTab]);

    return (
        <div role="tablist" className="r-text-md r-flex r-border-b-2 r-font-medium">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    id={tab.id}
                    role="tab"
                    aria-selected={activeTab === tab.label}
                    aria-controls={MOBILE_MENU_TABPANEL_ID}
                    onClick={() => setActiveTab(tab.label)}
                    className={`r-mb-[-2px] r-flex-grow r-pb-3 ${activeTab === tab.label ? 'r-border-b-4 r-border-b-tertiary-500' : ''} r-p-1`}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};
